export default __webpack_public_path__ + "static/media/WedaWilmaBuchner.6d8b8ee3.png";